import { apiAxios } from "./apiConfig"; // adjust path if needed

export interface MessageUser {
  email: string;
  userId: string;
  lastName: string;
  userName: string;
}

export interface MessageItem {
  users: MessageUser[];
  message: string;
  createdBy: string;
  messageId: string;
  createdDate: string;
}

export interface MessageGroup {
  totalMessages: string;
  roleName: string;
  messages: MessageItem[];
}

export interface MessageListResponse {
  status: boolean;
  data: MessageGroup[];
}

/**
 * Fetch CMS messages
 * @param type "list" | "study-team"
 * @param pageId number
 * @param limit number
 */
export const fetchCmsMessages = async (
  type: "list" | "study-team",
  pageId: number,
  limit: number,
): Promise<MessageListResponse> => {
  const response = await apiAxios.get<MessageListResponse>(`/message/${type}`, {
    params: {
      pageId,
      limit,
    },
  });

  return response.data;
};

// ----------------------
// CREATE MESSAGE
// ----------------------

export interface CreateMessagePayload {
  message: string;
  users: {
    id: string;
    isActive: string;
  }[];
}

export interface CreateMessageResponse {
  status: boolean;
  data: string;
}

export const createCmsMessage = async (
  payload: CreateMessagePayload,
): Promise<CreateMessageResponse> => {
  const response = await apiAxios.post<CreateMessageResponse>(
    "/message/create",
    payload,
  );

  return response.data;
};
